import React from "react";
//import { store } from '../../redux/store';
import GenerateRequestId from '../../common-function/GenerateRequestId';
import apiCallService from '../../service/api-call-service';
import { connect } from 'react-redux';
import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

class RblOtpVerify extends React.Component{
    constructor(props){
        super(props);
        this.state={
            messagePopUpHidden: false,
            message: '',
            severity: ''
        }
    }

    submitFormData = async (event) => {

        event.preventDefault();

        const uniqueId = GenerateRequestId.geneRateRequestId();
		const requestToSend = {
            "request": {
                "userid": process.env.REACT_APP_On_Boarding_Rbl_Ott_User_Id,
                "password": process.env.REACT_APP_On_Boarding_Rbl_Ott_Pwd,
                "bcagentid": process.env.REACT_APP_On_Boarding_Rbl_Ott_Bcagent_Id,
                "rbluniquerefno": this.props.rblUniqueRefNo,
                "uniquerefno": uniqueId,
                "ekyctype": "1",
                "encryptedpid": "4564645645",
                "encryptedhmac": "56f454564564564f64f",
                "sessionkeyvalue": "",
                "certificateidentifier": "456464564564",
                "registereddeviceserviceid": "",
                "registereddeviceserviceversion": "",
                "registereddeviceproviderid": "",
                "registereddevicecode": "",
                "registereddevicemodelid": "",
                "registereddevicepublickey": ""
            }
        }

        console.log('Rbl BioKyc Request ',requestToSend);

        const rblBioKycUrl = process.env.REACT_APP_On_Boarding_Rbl_BioKyc_Url;

        console.log('Rbl BioKyc Url ',rblBioKycUrl);

        const response = await apiCallService.postMethodCall(rblBioKycUrl, requestToSend);

        console.log('Rbl BioKyc Response ',response)

        if (!(response === undefined) && (response.response_code == 0)) {
           
            //store.dispatch(showKycDoneSection());   
            
            this.setState({ messagePopUpHidden: true });
			this.setState({ severity: "success" });
            this.setState({message:response.response.statusMessage});          
		}
		else if (!(response === undefined) && !(response.response_description === undefined)) {
			this.setState({ messagePopUpHidden: true });
			this.setState({ severity: "error" });
			this.setState({ message: response.response_description });		
		} else {
			this.setState({ messagePopUpHidden: true })
			this.setState({message:response});
			this.setState({ severity: "error" });
		}
    }
    
      render(){
          return(
            <div className="mid-contant">
            <div className="container">
                <form onSubmit={ this.submitFormData} autocomplete="off">
                <div className="row">
                    <div className="col-12">
                        <div className="head">					
                            <div className="step">
                                <ul>
                                    <li className="basic done">										
                                        <i className="dot"></i>
                                        <i className="line"></i>
                                        <span className="litxt">Basic</span>
                                    </li>
                                    <li className="bioscan done">										
                                        <i className="dot"></i>
                                        <i className="line"></i>
                                        <span className="litxt">Biomatric</span>
                                    </li>
                                    <li className="otp">							
                                        <i className="dot"></i>
                                        <i className="line"></i>
                                        <span className="litxt">OTP</span>
                                    </li>						
                                </ul>					
                            </div>					
                            <h2>RBL KYC Process</h2>
                        </div>
                    </div>
                    
                    <Snackbar
                       anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
					   open={this.state.messagePopUpHidden}
					   autoHideDuration={3000}
					   onClose={e => this.setState({ messagePopUpHidden: false })}
				    >
					   <Alert onClose={e => this.setState({ messagePopUpHidden: false })} severity={this.state.severity}>
						  {this.state.message}
					    </Alert>
				    </Snackbar>

                    <div className="col-12">
                        <div className="kycboxiframe">					
                            <iframe src={process.env.REACT_APP_On_Boarding_Rbl_Otp_Verify_Url}> </iframe>	
                            <button type="submit" className="btn btn-primary" id="">Submit</button>
                        </div>
                    </div>
                </div>
                </form>
            </div>
        </div>
            
        );
      } 
}

const mapStateToProps = ({ onBoarding: {rblUniqueRefNo} }) => ({
    rblUniqueRefNo
});

export default connect(mapStateToProps, null)(RblOtpVerify);